import { render, staticRenderFns } from "./AIColourExtractTemplate.vue?vue&type=template&id=5e72ab74&"
import script from "./AIColourExtractTemplate.vue?vue&type=script&lang=js&"
export * from "./AIColourExtractTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports